// LICENSE_CODE ZON
'use strict'; /*jslint node:true, browser:true, es6:true*/
(function(){
if (typeof module=='object' && module.exports)
    require('regenerator-runtime/runtime');
const define = typeof module!='object' || !module.exports ? self.define
    : require('../../../util/require_node.js').define(module, '..');
define(['/svc/billing/pub/utils/history.js', '/util/product_names.js',
    '/util/date.js', 'lodash4'],
    (history, product_names, date, _)=>
{
const E = {};

// get_latest_plan(cust, zid|zone|plans, opt)
E.get_latest_plan = (cust, z, opt)=>{
    let is_zlike = v=>Array.isArray(v) || v&&v.plan || v&&v.plans
        || typeof v=='string';
    if (opt===undefined && (is_zlike(cust) || cust==null&&!is_zlike(z)))
    {
        opt = z;
        z = cust;
        cust = null;
    }
    opt = opt||{};
    if (typeof z=='string')
    {
        let zid = z;
        let zn = (zid.startsWith('v__') ? cust&&cust.virtual_zones||{}
            : cust&&cust.zones||{})[zid];
        z = {plan: zn&&zn.plan};
        if (!(z.plans = opt.plan_arch&&opt.plan_arch[zid]))
            z.plans = zn&&zn.plans;
    }
    if (z&&z.plan && !opt.use_history
        && (!opt.d || +date()-date(opt.d)<date.ms.MIN))
    {
        return z.plan;
    }
    return history.get_any(z&&z.plans || Array.isArray(z)&&z || null, opt.d);
};

E.get_plan_product = plan=>{
    if (plan.type=='static' && plan.dc_light)
        return 'dc_light';
    if (plan.type=='static' && !plan.pool_ip_type && plan.unl_bw_tiers=='cn')
        return 'dc_unlim';
    if (plan.unl_bw_pkg && plan.type=='static')
        return 'res_static_unlim';
    if (plan.type=='static')
        return plan.pool_ip_type=='static_res' ? 'res_static' : 'dc';
    if ((plan.type=='resident' || plan.type=='unblocker') && plan.serp)
        return 'serp';
    if (!plan.type || plan.type=='resident')
        return plan.mobile&&'mobile' || 'res_rotating';
    if (plan.type=='dca' || plan.type=='datasets')
    {
        if (!plan.dca_managed)
            return 'ide';
        if (plan.ds_filter_api)
            return 'filter_api';
        if (plan.ds_global)
        {
            if (plan.ds_api&&plan.ds_easy_scraper)
                return 'easy_scraper';
            else if (plan.ds_api)
                return 'data_api';
            return 'datasets';
        }
        return 'dca';
    }
    if (plan.type=='bright_shield' && plan.assets)
        return 'assets_shield';
    if (plan.type=='bright_shield' && plan.scraping)
        return 'scraping_shield';
    return plan.type;
};

E.get_plan_network = plan=>{
    if (plan.type=='static' && plan.dc_light)
        return 'dc_light';
    if (plan.type=='static' && !plan.pool_ip_type && plan.unl_bw_tiers=='cn')
        return 'dc_unlim';
    if (plan.unl_bw_pkg && plan.type=='static')
        return 'res_static_unlim';
    if (plan.type=='static')
        return plan.pool_ip_type=='static_res'&&'res_static' || 'dc';
    if ((plan.type=='resident' || plan.type=='unblocker') && plan.serp)
        return 'serp';
    if (!plan.type || plan.type=='resident')
        return plan.mobile&&'mobile' || 'res_rotating';
    return plan.type;
};

E.get_zone_product = (cust, zid)=>{
    let plan = E.get_latest_plan(cust, zid);
    return plan && E.get_plan_product(plan);
};

E.get_zone_network = (cust, zid)=>{
    let plan = E.get_latest_plan(cust, zid);
    return plan && E.get_plan_network(plan);
};

E.is_shared_ppu = plan=>{
    if (plan && plan.type=='static')
        return (plan.ips_type||'shared')=='shared' && !!plan.ip_alloc_preset;
    if (plan && plan.type=='resident')
        return (plan.vips_type||'shared')=='shared';
    return false;
};

E.is_plan_custom = plan=>{
    if (_.isPlainObject(plan.cost) && !plan.cost&&!plan.slide)
        return false;
    return plan.precommit!=null || plan.cost!=null || plan.cost_override!=null;
};

E.get_network_label = net=>{
    if (net=='res_and_mobile')
        return 'Residential & Mobile';
    return product_names.get(net);
};

E.get_non_deleted_zones = (zones={})=>Object.keys(zones).reduce((obj, k)=>{
    if (zones[k] && (!zones[k].delete || date()<date(zones[k].delete)))
        obj[k] = zones[k];
    return obj;
}, {});

E.get_active_zones = cust=>{
    if (!cust || !cust.zones)
        return {};
    return Object.keys(cust.zones).reduce((acc, zid)=>{
        const plan = E.get_latest_plan(cust, zid);
        if (!plan.disable)
            acc[zid] = cust.zones[zid];
        return acc;
    }, {});
};

E.count_active_zones = cust=>Object.keys(E.get_active_zones(cust)).length;

return E; }); })(); // eslint-disable-line
